module.exports = __webpack_public_path__ + "img/word.cd068a32.png";